import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      light: {
        primary: '#5865F2', // Azul Discord
        secondary: '#36393F', // Gris oscuro Discord
        accent: '#7289DA', // Azul claro Discord
        error: '#ED4245', // Rojo Discord
        info: '#5865F2', // Azul Discord
        success: '#43A25A', // Verde Discord
        warning: '#FEE75C', // Amarillo Discord
      },
      dark: {
        primary: '#5865F2', // Azul Discord
        secondary: '#23272A', // Gris más oscuro Discord
        accent: '#7289DA', // Azul claro Discord
        error: '#ED4245', // Rojo Discord
        info: '#5865F2', // Azul Discord
        success: '#43A25A', // Verde Discord
        warning: '#FEE75C', // Amarillo Discord
      },
    },
  },
});
